import { Spinner } from '../../Spinner';

// One centered loader that fills the settings content area while the primary
// APIs (credits + premium) load, shared by the desktop and mobile Symphony
// surfaces so the whole page appears at once instead of card-by-card.
export function SettingsLoader() {
  return (
    <div style={styles.loader}>
      <Spinner />
    </div>
  );
}

const styles = {
  loader: { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '50vh' },
} satisfies Record<string, React.CSSProperties>;
